export class OrderSettingModel {
  public IsShowDescriptionBox: boolean;
  public IsShowTotalBox: boolean;
  public IsShowActionBox: boolean;
  public showComplate: boolean;
  public showPercent: boolean;
  public changeView: boolean;
  public changeCatView: boolean;
  public hideFastAccess: boolean;
  public OrderSize: OrderSizeModel[];
  public OrderDescriptionBox: boolean;
  public salonTableSize: boolean;
  constructor() {
    this.IsShowTotalBox = false;
    this.IsShowDescriptionBox = false;
    this.IsShowActionBox = false;
    this.showComplate = true;
    this.showPercent = false;
    this.changeView = false;
    this.changeCatView = false;
    this.hideFastAccess = false;
    this.salonTableSize = true;
  }
}
export class OrderSizeModel {
  width: number;
  height: number;
  top: number;
  left: number;
  key: number;
  saleBranchId: number;
}
